// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","note":"yfA8fwf0fSmAG-2nZtzL0","subtitle":"_20CJn6xJrLiGnmapaqjrqD"};